import { useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import moment from "moment";
import { useHistory } from 'react-router-dom';
import { MenuCampaign } from './components/MenuCampaign';
import "./css/CardCampaigns.css"
import { HistoricalCampaign } from './HistoricalCampaigns';

const HistoricalCard = ({ campaign }: { campaign: HistoricalCampaign }) => {
  const {
    id,
    nameCampaign,
    startCampaign,
    endCampaign,
    step,
    campaignBond,
    descriptionBond,
    minObjectives,
    maxObjectives,
    minQualification,
    descriptionCampaign,
    active,
    remandingDays,
    expectedProgress,
    createdObjectives,
    finishedObjectives,
    areas,
    sedes,
    totalCollaborators,
    realProgress
  } = campaign;
  const history = useHistory();
  const dateInitFormat = moment(startCampaign).utc().format('DD/MM/YYYY');
  const dateEndFormat = moment(endCampaign).utc().format('DD/MM/YYYY');

  useEffect(() => {

  }, [campaign])

  const goToObjectives = () => {
    history.push(`/objetivos/${id}`)
  }

  return (
    <>
      <Card className='cardCampaign'>
        <CardContent className="contentCampaign">
          <div className='topCampaign' style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            padding: '0 20px',
            width: '100%'
          }}>
            <div style={{
              flexGrow: 1,
            }}>
              <div><span className='titleCampaign'>{nameCampaign}</span></div>
              <div><span className='periodoCampaign'>{`Periodo: ${dateInitFormat} - ${dateEndFormat}`}</span></div>
            </div>
            <div className='btnCampaign' style={{
              width: '20px'
            }}>
              <div className='menCampaign'>
                <MenuCampaign id={id} campaign={{ ...campaign, status: "finalizado" }} />
              </div>
            </div>
          </div>
          <div className='definirCard' style={{
            padding: '11% 0',
            cursor: 'pointer'
          }}
            onClick={goToObjectives}
          >
            <div className='evaluarContain'>
              <div><span className='evaluarTxt'>{realProgress} %</span></div>
              <div className='contMsjEvaluar'><span className='msjEvaluar'>Finalizada</span> </div>
            </div>
            <div className="ev-line"></div>
            <div className='evaluarContain'>
              <div><span className='evaluarTxt'>{finishedObjectives} de {maxObjectives * totalCollaborators}</span></div>
              <div><span className='msjEvaluar'>Objetivos</span></div>
            </div>
            <div className="ev-line"></div>
            <div className='evaluarContain'>
              <div><span className='evaluarTxt'>{totalCollaborators}</span></div>
              <div><span className='msjEvaluar'>Colaboradores</span></div>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  )
}

export default HistoricalCard

